// Leaving a waiting list from its emails (/waiting-list/unsubscribe/<id>).
// Port of v1's waiting-list/unsubscribe/[id] (page + UnsubscribeView): GET
// /widget/<school-slug>/waiting-list/<id> names the listing (404 unless the
// entry is that school's), DELETE on the same address removes the entry.
// Pure.

import { BookingApiError } from "../../api";

/** The entry as the GET gives it (the customer's details are left out). */
export type WaitingListEntry = {
  _id: string;
  courseId?: { _id?: string; title?: string; schoolId?: string } | null;
  sessionId?: string | null;
  type?: string;
};

/** The listing's name, for "notifications about …". */
export const listingTitleOf = (entry: WaitingListEntry | null | undefined) => entry?.courseId?.title?.trim() || "this event";

/** What a failed DELETE means: a 404 is an entry already gone, which is
 * what the customer wanted (v1 shows them as unsubscribed too). */
export function unsubscribeFailure(error: unknown): "done" | "retry" {
  return error instanceof BookingApiError && error.status === 404 ? "done" : "retry";
}

export const UNSUBSCRIBE_FAILED = "Something went wrong. Please try again.";
